module.exports = __webpack_public_path__ + "static/media/scheme8.48ffe100.png";